import { YStack } from 'tamagui';

import { ShortEvent } from '@/src/api/eventsApi';
import { useRouter } from 'expo-router';
import Carousel from './Carousel';
import { ShowcaseCardsSkeleton } from './HomeSkeleton';
import ShowcaseEventCard from './ShowcaseEventCard';
import PSText from './ui/PSText';

export default function ShowcaseEventCarousel({
  title,
  subtitle,
  events,
  isLoading = false,
}: {
  title: string;
  subtitle: string;
  events: ShortEvent[];
  /** In flight: the heading is static copy, so only the cards go to bones. */
  isLoading?: boolean;
}) {
  const router = useRouter();
  return (
    <YStack gap="$lg">
      <YStack gap="$xs">
        {/* Light text is hardwired: every section sits on the brandDark landing page. */}
        <PSText.H1 color="$textWhite">{title}</PSText.H1>
        <PSText.Body2 color="$textWhiteMuted">{subtitle}</PSText.Body2>
      </YStack>
      <Carousel isBackgroundDark>
        {isLoading ? (
          <ShowcaseCardsSkeleton />
        ) : (
          events.map((event) => (
            <ShowcaseEventCard
              key={event.id}
              eventId={event.id}
              title={event.title}
              imageUrl={event.images.at(0)?.url}
              onPress={(eventId) => router.push(`/events/${eventId}`)}
            />
          ))
        )}
      </Carousel>
    </YStack>
  );
}
